import React, { useState, useEffect, useMemo } from "react";
import {
  Drawer,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";

const TableUF = ({ selectedUF, municipios, setOpen, open }) => {
  const [tab, setTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setTab(0);
    setSearchTerm("");
    setOpen(false);
  }, [selectedUF, setOpen]);

  
  const { municipiosSim, municipiosNao } = useMemo(() => {
    const municipiosArray = Array.isArray(municipios) ? municipios : [];

    const sim = municipiosArray.filter((m) => {
      const disponivel = m.disponivel;
      return disponivel === true || disponivel === "True" || disponivel === 1;
    });

    const nao = municipiosArray.filter((m) => {
      const disponivel = m.disponivel;
      return disponivel === false || disponivel === "False" || disponivel === 0;
    });

    return {
      municipiosSim: sim,
      municipiosNao: nao
    };
  }, [municipios]);

  const municipiosParaMostrar = useMemo(() => {
    const base = tab === 0 ? municipiosNao : municipiosSim;

    if (!searchTerm) return base;

    const normalizeText = (text) =>
      text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

    const termoNormalizado = normalizeText(searchTerm);

    return base.filter((mun) =>
      normalizeText(mun.name).includes(termoNormalizado)
    );
  }, [tab, municipiosNao, municipiosSim, searchTerm]);

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ style: { width: "90vw", maxWidth: 400 } }}
      >
        <div className="p-4">
          <h2 className="text-lg font-bold mb-2">
            Municípios - UF: {selectedUF}
          </h2>

          <div className="mb-2 text-sm text-gray-600">
            Total de municípios: {municipios.length}
          </div>

          <Tabs
            value={tab}
            onChange={(e, newValue) => {
              setTab(newValue);
              setSearchTerm("");
            }}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            className="mb-4"
          >
            <Tab label={`Sem serviço (${municipiosNao.length})`} />
            <Tab label={`Com serviço (${municipiosSim.length})`} />
          </Tabs>

          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Buscar município"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              marginBottom: 2,
            }}
          />

          <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{
                  backgroundColor: '#f0f0f0',
                }}>
                  <TableCell sx={{
                    fontWeight: 'bold',
                  }}>Município</TableCell>
                  <TableCell sx={{
                    fontWeight: 'bold',
                  }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {municipiosParaMostrar.length > 0 ? (
                  municipiosParaMostrar.map((mun, index) => (
                    <TableRow key={`${selectedUF}-${mun.name}-${mun.disponivel}-${index}`} sx={{
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                    }}>
                      <TableCell>{mun.name}</TableCell>
                      <TableCell>
                        <span style={{
                          color: mun.disponivel ? '#007b49' : '#ff0000',
                          fontWeight: 'bold'
                        }}>
                          {mun.disponivel ? 'Sim' : 'Não'}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      {tab === 0
                        ? "Nenhum município sem serviço encontrado"
                        : "Nenhum município com serviço encontrado"
                      }
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default TableUF;